export namespace StaffActions {
    export class LoadStaff {
    static readonly type = '[Global] Load Staff';
    constructor(public slug: string, public especialidad_uid?: string) {}
    }
    export class SetStaff {
      static readonly type = '[Global] Set Staff';
      constructor(public estado: boolean, public mensaje: string, public profesionales: any) {}
    }
  }
  